import * as React from 'react';

import classNames from 'classnames';

import CenteredLoadingSpinner from 'bundles/assess-common/components/CenteredLoadingSpinner';
import { loadingStates } from 'bundles/discussions/constants';

import _t from 'i18n!nls/discussions';

import 'css!./__styles__/ListBody';

type ListBodyProps = {
  loadingState: string;
  fossilized?: boolean;
  emptyStatePlaceholderText?: string;
};

export class ListBody extends React.LegacyComponentWithChildren<ListBodyProps> {
  static defaultProps = {
    children: [],
    fossilized: false,
    emptyStatePlaceholderText: '',
  };

  state = {
    transitionEnded: false,
  };

  private declare body: any;

  componentDidMount() {
    this.body.addEventListener('transitionend', () => {
      this.setState({ transitionEnded: true });
    });
  }

  componentWillReceiveProps() {
    this.setState({ transitionEnded: false });
  }

  render() {
    let body;
    const { loadingState, emptyStatePlaceholderText, children, fossilized } = this.props;
    const { transitionEnded } = this.state;
    if (loadingState === loadingStates.DONE && Array.isArray(children) && children?.length > 0) {
      body = <ol className="nostyle">{children}</ol>;
    } else if (loadingState === loadingStates.DONE && Array.isArray(children) && children?.length === 0) {
      body = (
        <div className="message" role="status" aria-live="polite">
          {emptyStatePlaceholderText || _t('No Results')}
        </div>
      );
    } else if (loadingState === loadingStates.ERROR) {
      body = (
        <div className="message" role="alert" aria-live="assertive">
          {_t('There was a problem, please reload the page and try again.')}
        </div>
      );
    } else if (loadingState === loadingStates.LOADING) {
      body = (
        <div className="message" role="alert" aria-live="polite">
          <CenteredLoadingSpinner />
        </div>
      );
    } else {
      body = <div />;
    }

    const bodyClasses = classNames('rc-ForumsV2__ListBody', {
      'c-list-expanded': loadingState === loadingStates.DONE && Array.isArray(children) && children.length > 0,
      'c-post-transition': transitionEnded,
    });

    const fossilClasses = classNames('c-pre-fossil', {
      'c-fossilized': fossilized,
    });
    return (
      <div
        className={bodyClasses}
        ref={(listBody) => {
          this.body = listBody;
        }}
      >
        <div className={fossilClasses} />
        {body}
      </div>
    );
  }
}
